import React from 'react'
import Ranking from '../../Components/DMM/Ranking'

const index = props => {
  return <Ranking />
}

export default index
